export const WEBSITE_NAVIGATOR_SUGGESTIONS = {
  "version": 1,
  "visibleCount": 7,
  "defaults": {
    "modes": {
      "knowledge": {
        "pool": [
          {
            "id": "defaults.knowledge.001",
            "de": "Welche Web-Systeme entwickelt Weros?",
            "en": "Which web systems does Weros build?"
          },
          {
            "id": "defaults.knowledge.002",
            "de": "Wie verbindet Weros Website, Daten und Automationen?",
            "en": "How does Weros connect websites, data and automation?"
          },
          {
            "id": "defaults.knowledge.003",
            "de": "Was unterscheidet ein Web-System von einer klassischen Website?",
            "en": "What makes a web system different from a classic website?"
          },
          {
            "id": "defaults.knowledge.004",
            "de": "Wie kann KI sinnvoll in digitale Abläufe eingebunden werden?",
            "en": "How can AI be integrated sensibly into digital workflows?"
          },
          {
            "id": "defaults.knowledge.005",
            "de": "Wie hilft die Lead Engine bei planbarer Kundengewinnung?",
            "en": "How does the Lead Engine support predictable lead generation?"
          },
          {
            "id": "defaults.knowledge.006",
            "de": "Was leistet der Website Navigator für Besucher?",
            "en": "What does the Website Navigator do for visitors?"
          },
          {
            "id": "defaults.knowledge.007",
            "de": "Wie unterstützt Weros interne Prozessoptimierung?",
            "en": "How does Weros support internal process optimization?"
          },
          {
            "id": "defaults.knowledge.008",
            "de": "Welche Aufgaben kann eine Web Application übernehmen?",
            "en": "Which tasks can a web application take over?"
          },
          {
            "id": "defaults.knowledge.009",
            "de": "Wie werden Kundenportale, Dashboards und Buchungsprozesse kombiniert?",
            "en": "How are customer portals, dashboards and booking processes combined?"
          },
          {
            "id": "defaults.knowledge.010",
            "de": "Wann lohnt sich ein eigenes System statt einzelner Tools?",
            "en": "When is a custom system better than separate tools?"
          },
          {
            "id": "defaults.knowledge.011",
            "de": "Wie können bestehende Tools in ein neues System integriert werden?",
            "en": "How can existing tools be integrated into a new system?"
          },
          {
            "id": "defaults.knowledge.012",
            "de": "Wie strukturiert Weros Daten für wiederkehrende Abläufe?",
            "en": "How does Weros structure data for recurring workflows?"
          },
          {
            "id": "defaults.knowledge.013",
            "de": "Welche Rolle spielen Admin-Boards in euren Lösungen?",
            "en": "What role do admin boards play in your solutions?"
          },
          {
            "id": "defaults.knowledge.014",
            "de": "Wie bleiben digitale Prozesse für Teams nachvollziehbar?",
            "en": "How do digital processes stay transparent for teams?"
          },
          {
            "id": "defaults.knowledge.015",
            "de": "Welche Automationen sind für kleine Teams besonders sinnvoll?",
            "en": "Which automations are especially useful for small teams?"
          },
          {
            "id": "defaults.knowledge.016",
            "de": "Wie kann eine Website qualifizierte Anfragen besser vorbereiten?",
            "en": "How can a website prepare qualified inquiries more effectively?"
          },
          {
            "id": "defaults.knowledge.017",
            "de": "Wie kann ein System kalte Leads in wärmere Kontakte verwandeln?",
            "en": "How can a system turn cold leads into warmer contacts?"
          },
          {
            "id": "defaults.knowledge.018",
            "de": "Welche Daten braucht die Lead Engine für gutes Prospecting?",
            "en": "Which data does the Lead Engine need for good prospecting?"
          },
          {
            "id": "defaults.knowledge.019",
            "de": "Wie werden Outreach-Prozesse personalisiert?",
            "en": "How are outreach processes personalized?"
          },
          {
            "id": "defaults.knowledge.020",
            "de": "Wie verhindert Weros, dass Automationen unpersönlich wirken?",
            "en": "How does Weros prevent automations from feeling impersonal?"
          },
          {
            "id": "defaults.knowledge.021",
            "de": "Wie kann ein Website Navigator passende Inhalte ausspielen?",
            "en": "How can a Website Navigator surface matching content?"
          },
          {
            "id": "defaults.knowledge.022",
            "de": "Wie beantwortet der Navigator Fragen ohne Halluzinationen?",
            "en": "How does the Navigator answer questions without hallucinations?"
          },
          {
            "id": "defaults.knowledge.023",
            "de": "Welche Inhalte kann der Navigator als Wissensbasis nutzen?",
            "en": "Which content can the Navigator use as its knowledge base?"
          },
          {
            "id": "defaults.knowledge.024",
            "de": "Wie werden Dateien und Website-Inhalte im Navigator nutzbar?",
            "en": "How are files and website content made usable in the Navigator?"
          },
          {
            "id": "defaults.knowledge.025",
            "de": "Wie funktioniert die Terminbuchung im Navigator?",
            "en": "How does appointment booking work inside the Navigator?"
          },
          {
            "id": "defaults.knowledge.026",
            "de": "Wie kann der Navigator Kontaktanfragen vorqualifizieren?",
            "en": "How can the Navigator pre-qualify inquiries?"
          },
          {
            "id": "defaults.knowledge.027",
            "de": "Was prüft Weros bei Sichtbarkeit in KI-Suchen?",
            "en": "What does Weros check for visibility in AI search?"
          },
          {
            "id": "defaults.knowledge.028",
            "de": "Wie hängt GEO mit digitaler Markenpositionierung zusammen?",
            "en": "How is GEO connected to digital brand positioning?"
          },
          {
            "id": "defaults.knowledge.029",
            "de": "Wie werden Inhalte für Google und KI-Assistenten strukturiert?",
            "en": "How is content structured for Google and AI assistants?"
          },
          {
            "id": "defaults.knowledge.030",
            "de": "Wie hilft Weros dabei, als Marke klarer auffindbar zu werden?",
            "en": "How does Weros help a brand become easier to find?"
          },
          {
            "id": "defaults.knowledge.031",
            "de": "Welche Rolle spielen Trust-Signale in KI-Antworten?",
            "en": "What role do trust signals play in AI answers?"
          },
          {
            "id": "defaults.knowledge.032",
            "de": "Wie lässt sich ein bestehender Webauftritt zu einem System ausbauen?",
            "en": "How can an existing web presence be expanded into a system?"
          },
          {
            "id": "defaults.knowledge.033",
            "de": "Welche Prozesse lassen sich hinter einer Website automatisieren?",
            "en": "Which processes can be automated behind a website?"
          },
          {
            "id": "defaults.knowledge.034",
            "de": "Wie können Formulare, CRM und E-Mail-Prozesse zusammenspielen?",
            "en": "How can forms, CRM and email processes work together?"
          },
          {
            "id": "defaults.knowledge.035",
            "de": "Wie unterstützt Weros sichere Datenhaltung?",
            "en": "How does Weros support secure data storage?"
          },
          {
            "id": "defaults.knowledge.036",
            "de": "Wie werden Rollen und Zugänge in Portalen geplant?",
            "en": "How are roles and access rights planned in portals?"
          },
          {
            "id": "defaults.knowledge.037",
            "de": "Wie können Produktlogik und Zahlungsabwicklung integriert werden?",
            "en": "How can product logic and payments be integrated?"
          },
          {
            "id": "defaults.knowledge.038",
            "de": "Wie lassen sich interne Dokumente besser auffindbar machen?",
            "en": "How can internal documents be made easier to find?"
          },
          {
            "id": "defaults.knowledge.039",
            "de": "Wie können Teams durch Assistenzsysteme Zeit sparen?",
            "en": "How can teams save time with assistance systems?"
          },
          {
            "id": "defaults.knowledge.040",
            "de": "Was bringt ein Telefon-Assistenzsystem für wiederkehrende Anfragen?",
            "en": "What does a phone assistance system do for recurring requests?"
          },
          {
            "id": "defaults.knowledge.041",
            "de": "Wie kann KI Kommunikation und Abstimmung im Unternehmen verbessern?",
            "en": "How can AI improve communication and coordination inside a company?"
          },
          {
            "id": "defaults.knowledge.042",
            "de": "Welche Systeme eignen sich für Unternehmen mit vielen Anfragen?",
            "en": "Which systems fit companies with many inquiries?"
          },
          {
            "id": "defaults.knowledge.043",
            "de": "Welche Lösung passt, wenn viele Inhalte schnell gefunden werden müssen?",
            "en": "Which solution fits when many contents need to be found quickly?"
          },
          {
            "id": "defaults.knowledge.044",
            "de": "Wie kann ein System Prioritäten für Leads sichtbar machen?",
            "en": "How can a system make lead priorities visible?"
          },
          {
            "id": "defaults.knowledge.045",
            "de": "Wie bleiben Automationen kontrollierbar und nachvollziehbar?",
            "en": "How do automations stay controllable and transparent?"
          },
          {
            "id": "defaults.knowledge.046",
            "de": "Wie kann Weros aus bestehenden Informationen erste Systemideen ableiten?",
            "en": "How can Weros derive initial system ideas from existing information?"
          },
          {
            "id": "defaults.knowledge.047",
            "de": "Welche Fragen klärt Weros vor der Systemarchitektur?",
            "en": "Which questions does Weros clarify before system architecture?"
          },
          {
            "id": "defaults.knowledge.048",
            "de": "Wie wird entschieden, ob Navigator, Lead Engine oder Web App passt?",
            "en": "How is it decided whether Navigator, Lead Engine or a Web App fits?"
          },
          {
            "id": "defaults.knowledge.049",
            "de": "Wie lassen sich digitale Abläufe schrittweise statt auf einmal erneuern?",
            "en": "How can digital workflows be improved step by step instead of all at once?"
          },
          {
            "id": "defaults.knowledge.050",
            "de": "Wie misst Weros, ob ein System wirklich Wirkung erzielt?",
            "en": "How does Weros measure whether a system creates real impact?"
          },
          {
            "id": "defaults.knowledge.051",
            "de": "Wie können Reports und Dashboards Entscheidungen erleichtern?",
            "en": "How can reports and dashboards make decisions easier?"
          },
          {
            "id": "defaults.knowledge.052",
            "de": "Wie werden Datenschutz und Automatisierung zusammen gedacht?",
            "en": "How are privacy and automation planned together?"
          },
          {
            "id": "defaults.knowledge.053",
            "de": "Welche Bestandteile gehören zu einer skalierbaren Systembasis?",
            "en": "Which elements belong to a scalable system foundation?"
          },
          {
            "id": "defaults.knowledge.054",
            "de": "Wie kann ein digitales System mit dem Unternehmen mitwachsen?",
            "en": "How can a digital system grow with the company?"
          },
          {
            "id": "defaults.knowledge.055",
            "de": "Welche typischen Engpässe erkennt Weros in digitalen Abläufen?",
            "en": "Which typical bottlenecks does Weros identify in digital workflows?"
          },
          {
            "id": "defaults.knowledge.056",
            "de": "Wie werden aus wiederkehrenden manuellen Aufgaben stabile Workflows?",
            "en": "How do recurring manual tasks become stable workflows?"
          },
          {
            "id": "defaults.knowledge.057",
            "de": "Wie kann ein System Besucher schneller zur richtigen Entscheidung führen?",
            "en": "How can a system guide visitors to the right decision faster?"
          },
          {
            "id": "defaults.knowledge.058",
            "de": "Welche Rolle spielt Content- und Datenmanagement in euren Systemen?",
            "en": "What role do content and data management play in your systems?"
          },
          {
            "id": "defaults.knowledge.059",
            "de": "Wie kann Weros operative Abläufe und Markenwirkung verbinden?",
            "en": "How can Weros connect operational workflows and brand impact?"
          }
        ]
      },
      "booking": {
        "pool": [
          {
            "id": "defaults.booking.001",
            "de": "Wann ist ein guter Zeitpunkt, über Automationen zu sprechen?",
            "en": "When is a good time to talk about automation?"
          },
          {
            "id": "defaults.booking.002",
            "de": "Können wir in einem Termin klären, welches System passt?",
            "en": "Can we clarify which system fits in one appointment?"
          },
          {
            "id": "defaults.booking.003",
            "de": "Wie bereite ich ein Gespräch über Lead Engine oder Navigator vor?",
            "en": "How should I prepare for a call about Lead Engine or Navigator?"
          },
          {
            "id": "defaults.booking.004",
            "de": "Lässt sich eine erste Einschätzung in 30 Minuten besprechen?",
            "en": "Can an initial assessment be discussed in 30 minutes?"
          },
          {
            "id": "defaults.booking.005",
            "de": "Kann ein Termin zeigen, ob eine Web App sinnvoll ist?",
            "en": "Can an appointment show whether a web app makes sense?"
          },
          {
            "id": "defaults.booking.006",
            "de": "Welche Unterlagen helfen vor einem Gespräch mit Weros?",
            "en": "Which materials help before a call with Weros?"
          },
          {
            "id": "defaults.booking.007",
            "de": "Kann im Termin direkt über bestehende Prozesse gesprochen werden?",
            "en": "Can we discuss existing processes directly in the appointment?"
          },
          {
            "id": "defaults.booking.008",
            "de": "Wie schnell lässt sich ein Ersttermin für ein Systemprojekt finden?",
            "en": "How quickly can we find an initial appointment for a system project?"
          },
          {
            "id": "defaults.booking.009",
            "de": "Kann das Gespräch online stattfinden?",
            "en": "Can the conversation happen online?"
          },
          {
            "id": "defaults.booking.010",
            "de": "Kann ich im Termin mehrere Lösungswege vergleichen?",
            "en": "Can I compare several solution paths in the appointment?"
          },
          {
            "id": "defaults.booking.011",
            "de": "Welche Fragen sollte ich vor einem Automationsgespräch sammeln?",
            "en": "Which questions should I collect before an automation call?"
          },
          {
            "id": "defaults.booking.012",
            "de": "Kann Weros im Termin eine grobe Priorisierung geben?",
            "en": "Can Weros give a rough prioritization in the appointment?"
          },
          {
            "id": "defaults.booking.013",
            "de": "Lässt sich ein Termin mit mehreren Teammitgliedern planen?",
            "en": "Can an appointment include several team members?"
          },
          {
            "id": "defaults.booking.014",
            "de": "Kann ein Gespräch klären, ob zuerst Analyse oder Umsetzung sinnvoll ist?",
            "en": "Can a call clarify whether analysis or implementation should come first?"
          },
          {
            "id": "defaults.booking.015",
            "de": "Wie läuft ein erstes Gespräch zu internen Prozessen ab?",
            "en": "How does an initial call about internal processes work?"
          },
          {
            "id": "defaults.booking.016",
            "de": "Kann Weros im Termin vorhandene Tools einordnen?",
            "en": "Can Weros assess existing tools during the appointment?"
          },
          {
            "id": "defaults.booking.017",
            "de": "Kann ich eine konkrete Prozessfrage in den Termin mitbringen?",
            "en": "Can I bring a concrete process question to the appointment?"
          },
          {
            "id": "defaults.booking.018",
            "de": "Ist ein Gespräch sinnvoll, wenn die Anforderungen noch unscharf sind?",
            "en": "Is a call useful if the requirements are still unclear?"
          },
          {
            "id": "defaults.booking.019",
            "de": "Kann im Termin über Datenschutz und Schnittstellen gesprochen werden?",
            "en": "Can privacy and integrations be discussed in the appointment?"
          },
          {
            "id": "defaults.booking.020",
            "de": "Wie viel Vorlauf braucht ein Gespräch mit Weros?",
            "en": "How much lead time is needed for a call with Weros?"
          },
          {
            "id": "defaults.booking.021",
            "de": "Kann ein Termin helfen, Aufwand und nächste Schritte einzuordnen?",
            "en": "Can an appointment help estimate effort and next steps?"
          },
          {
            "id": "defaults.booking.022",
            "de": "Lässt sich nach dem Termin ein konkretes Briefing ableiten?",
            "en": "Can a concrete briefing be derived after the appointment?"
          },
          {
            "id": "defaults.booking.023",
            "de": "Kann ich vor dem Termin eine Website oder einen Prozess nennen?",
            "en": "Can I mention a website or process before the appointment?"
          },
          {
            "id": "defaults.booking.024",
            "de": "Welche Person sollte bei einem Systemgespräch dabei sein?",
            "en": "Who should join a system discovery call?"
          }
        ]
      },
      "contact": {
        "pool": [
          {
            "id": "defaults.contact.001",
            "de": "Welche Informationen helfen für eine erste Systemeinschätzung?",
            "en": "Which information helps with an initial system assessment?"
          },
          {
            "id": "defaults.contact.002",
            "de": "Kann ich eine Prozessidee kurz beschreiben?",
            "en": "Can I briefly describe a process idea?"
          },
          {
            "id": "defaults.contact.003",
            "de": "Wie schildere ich am besten ein Automationsproblem?",
            "en": "How should I describe an automation problem?"
          },
          {
            "id": "defaults.contact.004",
            "de": "Kann Weros eine bestehende Tool-Landschaft einschätzen?",
            "en": "Can Weros assess an existing tool landscape?"
          },
          {
            "id": "defaults.contact.005",
            "de": "Welche Details braucht ihr zu Leads und Zielgruppen?",
            "en": "Which details do you need about leads and target groups?"
          },
          {
            "id": "defaults.contact.006",
            "de": "Kann ich eine Website oder ein Portal als Beispiel nennen?",
            "en": "Can I mention a website or portal as an example?"
          },
          {
            "id": "defaults.contact.007",
            "de": "Wie beschreibe ich interne Abläufe für eine Anfrage?",
            "en": "How do I describe internal workflows for an inquiry?"
          },
          {
            "id": "defaults.contact.008",
            "de": "Kann ich mehrere mögliche Systeme in einer Anfrage bündeln?",
            "en": "Can I combine several possible systems in one inquiry?"
          },
          {
            "id": "defaults.contact.009",
            "de": "Welche Ziele sollte eine Anfrage an Weros enthalten?",
            "en": "Which goals should an inquiry to Weros include?"
          },
          {
            "id": "defaults.contact.010",
            "de": "Kann ich erst eine grobe Idee statt eines fertigen Briefings senden?",
            "en": "Can I send a rough idea instead of a finished briefing?"
          },
          {
            "id": "defaults.contact.011",
            "de": "Wie viel Kontext braucht Weros zu bestehenden Daten?",
            "en": "How much context does Weros need about existing data?"
          },
          {
            "id": "defaults.contact.012",
            "de": "Kann ich Screenshots oder Dateien später ergänzen?",
            "en": "Can I add screenshots or files later?"
          },
          {
            "id": "defaults.contact.013",
            "de": "Welche Fragen helfen beim Start einer Lead-Engine-Anfrage?",
            "en": "Which questions help start a Lead Engine inquiry?"
          },
          {
            "id": "defaults.contact.014",
            "de": "Wie lässt sich eine Anfrage für einen Website Navigator formulieren?",
            "en": "How can an inquiry for a Website Navigator be phrased?"
          },
          {
            "id": "defaults.contact.015",
            "de": "Welche Angaben sind für eine Web Application wichtig?",
            "en": "Which details matter for a web application?"
          },
          {
            "id": "defaults.contact.016",
            "de": "Kann ich eine Anfrage ohne technische Spezifikation stellen?",
            "en": "Can I send an inquiry without a technical specification?"
          },
          {
            "id": "defaults.contact.017",
            "de": "Wie beschreibe ich, welche Aufgaben heute manuell laufen?",
            "en": "How do I describe which tasks are currently manual?"
          },
          {
            "id": "defaults.contact.018",
            "de": "Kann Weros bei der Priorisierung mehrerer Ideen helfen?",
            "en": "Can Weros help prioritize several ideas?"
          },
          {
            "id": "defaults.contact.019",
            "de": "Welche Informationen sind für Schnittstellen wichtig?",
            "en": "Which information matters for integrations?"
          },
          {
            "id": "defaults.contact.020",
            "de": "Kann ich Datenschutzanforderungen direkt mit angeben?",
            "en": "Can I include privacy requirements right away?"
          },
          {
            "id": "defaults.contact.021",
            "de": "Wie formuliere ich eine Anfrage für ein Kundenportal?",
            "en": "How do I phrase an inquiry for a customer portal?"
          },
          {
            "id": "defaults.contact.022",
            "de": "Kann eine Anfrage auch nur eine Problemstellung enthalten?",
            "en": "Can an inquiry contain only a problem statement?"
          },
          {
            "id": "defaults.contact.023",
            "de": "Welche nächsten Schritte folgen nach einer Anfrage?",
            "en": "Which next steps follow after an inquiry?"
          },
          {
            "id": "defaults.contact.024",
            "de": "Wie kann ich Weros einen bestehenden Engpass schildern?",
            "en": "How can I describe an existing bottleneck to Weros?"
          }
        ]
      }
    }
  },
  "contexts": {
    "website-navigator": {
      "modes": {
        "knowledge": {
          "pool": [
            {
              "id": "contexts.website-navigator.knowledge.001",
              "de": "Wie verhindert der Website-Navigator falsche Antworten?",
              "en": "How does the Website Navigator prevent false answers?"
            },
            {
              "id": "contexts.website-navigator.knowledge.002",
              "de": "Welche Inhalte kann der Website-Navigator nutzen?",
              "en": "Which content can the Website Navigator use?"
            },
            {
              "id": "contexts.website-navigator.knowledge.003",
              "de": "Wie funktioniert die Terminbuchung im Navigator?",
              "en": "How does booking work in the Navigator?"
            },
            {
              "id": "contexts.website-navigator.knowledge.004",
              "de": "Kann der Navigator mehrsprachig arbeiten?",
              "en": "Can the Navigator work in multiple languages?"
            },
            {
              "id": "contexts.website-navigator.knowledge.005",
              "de": "Was passiert, wenn keine passende Quelle vorliegt?",
              "en": "What happens if no suitable source exists?"
            },
            {
              "id": "contexts.website-navigator.knowledge.006",
              "de": "Kann der Navigator Besucher zur passenden Unterseite führen?",
              "en": "Can the Navigator guide visitors to the right subpage?"
            },
            {
              "id": "contexts.website-navigator.knowledge.007",
              "de": "Welche Sonderfunktionen lassen sich ergänzen?",
              "en": "Which special functions can be added?"
            }
          ]
        }
      }
    }
  }
};
